import { supportedLanguages } from "$lib/translations/translations";

export default function buildLanguagePath(path: string, language: string): string {
	language = language.toLowerCase();
	const pathSegments = path.split('/');
	const isCurrentRouteInPt = !supportedLanguages.filter(lang => lang !== 'pt').includes(pathSegments[1]);

	pathSegments.splice(0, isCurrentRouteInPt ? 1 : 2);

	return `${language === 'pt' ? '' : '/' + language}/${pathSegments.join('/')}`;
}